import Axios from '@/config/axios'

// for release notes see: https://docs.adyen.com/checkout/components-drop-in-release-notes
export const ADYEN_SDK_URL =
  'https://checkoutshopper-live-us.adyen.com/checkoutshopper/sdk/3.0.0/adyen.js'
export const ADYEN_STYLES_URL =
  'https://checkoutshopper-live-us.adyen.com/checkoutshopper/sdk/3.0.0/adyen.css'

export const ADYEN_ENVS = {
  test: 'test',
  live: 'live',
}

// see: https://docs.adyen.com/checkout/payment-result-codes
export const ADYEN_PAYMENT_RESULT_CODES = {
  AuthenticationFinished: 'AuthenticationFinished', // not needed
  Authorised: 'Authorised',
  Cancelled: 'Cancelled',
  ChallengeShopper: 'ChallengeShopper', // not needed
  Error: 'Error',
  IdentifyShopper: 'IdentifyShopper', // not needed
  Pending: 'Pending',
  Received: 'Received',
  RedirectShopper: 'RedirectShopper', // handled by the backend
  Refused: 'Refused',
}

const ORIGIN_KEY_URL_PATH = 'api/checkout/payment/origin_key'
const PAYMENT_METHODS_URL_PATH = 'api/checkout/payment/payment_methods'
const MAKE_PAYMENT_URL_PATH = 'api/checkout/payment/payments'
const PAYMENT_DETAILS_URL_PATH = 'api/checkout/payment/payments/details'
const APPLE_PAY_AUTHORIZE_MERCHANT_URL_PATH = 'applepay_merchants/authorize'

const getRootUrl = (rootGetters, path) => rootGetters['page/getRootUrl'](path)

export default {
  namespaced: true,
  actions: {
    fetchAdyenOriginKey({ rootGetters }) {
      const url = getRootUrl(rootGetters, ORIGIN_KEY_URL_PATH)
      return Axios.post(url, {
        origin_domain: window.location.origin,
      }).then(response => response.data.originKeys[window.location.origin])
    },

    fetchPaymentMethods({ rootGetters }) {
      const url = getRootUrl(rootGetters, PAYMENT_METHODS_URL_PATH)
      return Axios.get(url).then(({ data }) => data)
    },

    makePayment({ rootGetters }, { data, orderNumber }) {
      const url = getRootUrl(rootGetters, MAKE_PAYMENT_URL_PATH)
      // TODO: B2C-808 define client-side redirect url here instead of hardcoding it in the backend
      const paymentDetailsURLPath =
        PAYMENT_DETAILS_URL_PATH + '/' + data?.paymentMethod?.type + '/' + orderNumber
      data.returnUrl = getRootUrl(rootGetters, paymentDetailsURLPath)
      data.browserInfo = {
        colorDepth: window.screen.colorDepth,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timeZoneOffset: new Date().getTimezoneOffset(),
        javaEnabled: navigator.javaEnabled(),
      }
      On.Analytics.trackCheckoutEvent('Payment', data?.paymentMethod?.type || 'unknown')
      if (data?.storePaymentMethod) On.Analytics.trackCheckoutEvent('Payment', 'save-payment')
      return Axios.post(url, { data }).then(({ data }) => data)
    },

    authorizeApplePayMerchant({ rootGetters }, { validationURL }) {
      const url = getRootUrl(rootGetters, APPLE_PAY_AUTHORIZE_MERCHANT_URL_PATH)
      return Axios.post(url, { url: validationURL }).then(({ data }) => data)
    },
  },
}
